import { FC } from 'react';
import { Container, createTheme, CssBaseline, ThemeProvider } from '@mui/material';
import Carrousel from './app/components/global/Carrousel';
import Mission from './app/components/sections/Mission';
import Selectivity from './app/components/sections/Selectivity';
import TrustProof from './app/components/sections/TrustProof';
import About from './app/components/sections/About';
import Offer from './app/components/sections/Offer';
import Horses from './app/components/sections/Horses';
import Method from './app/components/sections/Method';
import Pricing from './app/components/sections/Pricing';
import Contact from './app/components/sections/Contact';
import Layout from './app/components/routes/Layout';
import Footer from './app/components/footer/Footer';
import Team from './app/components/sections/Team';
import { ThemeProvider as CustomThemeProvider, useThemeContext } from './app/components/global/ThemeContext';
import { designTokens } from './app/theme/designTokens';

const AppContent: FC = () => {
  const { darkMode } = useThemeContext();
  const colors = darkMode ? designTokens.colors.dark : designTokens.colors.light;

  const dynamicTheme = createTheme({
    palette: {
      mode: darkMode ? 'dark' : 'light',
      primary: {
        main: colors.primary,
        dark: colors.primaryDark,
      },
      background: {
        default: colors.background.default,
        paper: colors.background.elevated,
      },
      text: {
        primary: colors.text.primary,
        secondary: colors.text.secondary,
      },
      divider: colors.border.default,
    },
    typography: {
      fontFamily: designTokens.typography.fontFamily.sans,
    },
    components: {
      MuiButtonBase: {
        styleOverrides: {
          root: {
            '&.Mui-focusVisible': {
              outline: `2px solid ${colors.primary}`,
              outlineOffset: '2px',
            },
          },
        },
      },
      MuiLink: {
        styleOverrides: {
          root: {
            '&:focus-visible': {
              outline: `2px solid ${colors.primary}`,
              outlineOffset: '2px',
            },
          },
        },
      },
      MuiCssBaseline: {
        styleOverrides: {
          'a:focus-visible, button:focus-visible, [role="button"]:focus-visible': {
            outline: `2px solid ${colors.primary}`,
            outlineOffset: '2px',
          },
        },
      },
    },
  });

  return (
    <ThemeProvider theme={dynamicTheme}>
      <CssBaseline />
      <header style={{ position: 'sticky', top: 0, zIndex: 1100 }}>
        <nav>
          <Layout />
        </nav>
      </header>
      <section id="top">
        <Carrousel />
      </section>
      <section>
        <Mission />
      </section>
      <section>
        <Selectivity />
      </section>
      <section>
        <TrustProof />
      </section>
      <section id="about">
        <About />
      </section>
      <Container maxWidth="md">
        <section id="offer">
          <Offer />
        </section>
        <section id="horses">
          <Horses />
        </section>
        <section id="method">
          <Method />
        </section>
        <section id="pricing">
          <Pricing />
        </section>
        <section id="team">
          <Team />
        </section>
        <section id="contact">
          <Contact />
        </section>
      </Container>
      <Footer />
    </ThemeProvider>
  );
};

const App: FC = () => (
  <CustomThemeProvider>
    <AppContent />
  </CustomThemeProvider>
);

export default App;
